module.exports = __webpack_public_path__ + "static/testi-4-e3f2a5f9abc599f4262cb7224e9c2311.jpg";